import React, {useContext, useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import RightFloatingBubble from 'components/chat/RightFloatingBubble';
import NotificationPopup from 'components/notification/NotificationPopup';
import SignInPopup from 'components/login/SignInPopup';
import {useNotification} from 'util/NotificationContext';
import {UserContext} from 'components/user/UserContext';
import {usePopup} from 'popup/PopupContext';
import 'styles/menu/RightPanel.css';
import ChatIconSvg from 'util/svg/ChatIconSvg';
import NotificationSvg from 'util/svg/NotificationSvg';
import {singlePageLocation} from 'util/locationUtil';

const RightPanel = () => {
    const [showRightChat, setShowRightChat] = useState(false);
    const [showNotificationContent, setShowNotificationContent] = useState(false);
    const [isNotificationPage, setIsNotificationPage] = useState(false);
    const [isChatPage, setIsChatPage] = useState(false);
    const {missedMessages, missedNotifications} = useNotification();
    const {user} = useContext(UserContext);
    const {openPopup} = usePopup();
    const location = useLocation();
    const wasOnChatRef = useRef(false);

    const notificationRef = useRef(null);
    const notificationButtonRef = useRef(null);

    useEffect(() => {
        if (showNotificationContent) {
            function handleClickOutside(event) {
                if (
                    notificationRef.current &&
                    !notificationRef.current.contains(event.target) &&
                    notificationButtonRef.current &&
                    !notificationButtonRef.current.contains(event.target)
                ) {
                    setShowNotificationContent(false);
                }
            }

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [showNotificationContent]);

    const handleChatClick = () => {
        if (user.isLoggedIn) {
            setShowRightChat(!showRightChat);
            setShowNotificationContent(false);
        } else {
            openPopup(<SignInPopup/>, () => {
            }, true);
        }
    };

    const handleNotificationClick = () => {
        setShowRightChat(false);
        setShowNotificationContent(!showNotificationContent);
    };

    const handleCloseChat = () => {
        setShowRightChat(false);
    };

    // Update `isNotificationPage` only when the location changes
    useEffect(() => {
        const isOnNotifications = singlePageLocation(location.pathname) === 'notifications';
        setIsNotificationPage(isOnNotifications);
        const isOnChat = singlePageLocation(location.pathname) === 'chat';
        setIsChatPage(isOnChat);
        if (isOnChat) {
            wasOnChatRef.current = true;
            setShowRightChat(false);
        } else if (wasOnChatRef.current) {
            setShowRightChat(true);
            wasOnChatRef.current = false;
        }
    }, [location.pathname]);

    return (
        <>
            <div className="side-content-wrapper">
                <div className="notification-popup">
                    {showRightChat && (
                        <RightFloatingBubble onClose={handleCloseChat}/>
                    )}
                    {showNotificationContent && (
                        <div style={{paddingRight: '65px'}}>
                            <div ref={notificationRef} className="chat-bubble-container" style={{padding: '10px'}}>
                                <NotificationPopup onHide={() => setShowNotificationContent(false)}/>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="floating-show-chat-button">
                {user.isLoggedIn && !isNotificationPage && ( // Hide icon on /notifications
                    <div
                        ref={notificationButtonRef}
                        className={`notification-holder-div ${showNotificationContent ? 'active' : ''}`}
                        onClick={handleNotificationClick}
                    >
                        <NotificationSvg color={showNotificationContent ? '#D9D9D9' : 'black'}/>
                        {missedNotifications > 0 && !showNotificationContent && (
                            <div className="small-red-notification-bubble"/>
                        )}
                    </div>
                )}
                <div style={{width: '64px'}}>
                    {!isChatPage && (
                        <div className="position-relative">
                            <div
                                className={`notification-holder-div ${showRightChat ? 'active' : ''}`}
                                onClick={handleChatClick}
                            >
                                <ChatIconSvg color={showRightChat ? '#D9D9D9' : 'black'}/>
                            </div>
                            {missedMessages > 0 && (
                                <div className="small-red-notification-bubble"/>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
        ;
};

export default RightPanel;
